import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";

interface DetailFieldProps {
  label: string;
  message?: string | null;
  subMessage?: string | null;
  onClick?: () => void;
  extraInfo?: React.ReactNode | null;
  fullWidth?: boolean;
  className?: string;
}

export const DetailField = ({
  label,
  message,
  subMessage,
  fullWidth = true,
  className,
  extraInfo,
  onClick,
}: DetailFieldProps) => (
  <Stack gap="sm" fullWidth={fullWidth} className={className}>
    <Stack direction="row" align="center" gap="xs">
      <Typography variant="subtitleW3" textColor="tertiary">
        {label}
      </Typography>
      {extraInfo && (
        <Tooltip>
          <TooltipTrigger asChild>
            <InformationCircleIcon className="h-4 w-4 text-tertiary-text" />
          </TooltipTrigger>
          <TooltipContent maxWidth="xl">{extraInfo}</TooltipContent>
        </Tooltip>
      )}
    </Stack>
    <Typography
      variant="bodyW1"
      onClick={onClick}
      className={onClick ? "cursor-pointer underline" : ""}
    >
      {message}
    </Typography>
    {subMessage && (
      <Typography variant="captionW1" textColor="tertiary">
        {subMessage}
      </Typography>
    )}
  </Stack>
);
